import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';
import invariant from 'invariant';
import querystring from 'query-string';

export default function updateOrderItem(params) {
    const {
        baseUrl,
        brandId,
        country,
        language,
        partNumber,
        newPartNumber,
        quantity,
        uberToken,
        clientId,
        clientSecret,
        langId,
        additionalHeaders = {},
    } = params;

    invariant(baseUrl, 'baseUrl is a required param of updateOrderItem()');
    invariant(brandId, 'brandId is a required param of updateOrderItem()');
    invariant(country, 'country is a required param of updateOrderItem()');
    invariant(language, 'language is a required param of updateOrderItem()');
    invariant(partNumber, 'partNumber is a required param of updateOrderItem()');
    invariant(typeof quantity === 'number', 'quantity is a required param of updateOrderItem()');
    invariant(uberToken, 'uberToken is a required param of updateOrderItem()');
    invariant(clientId, 'clientId is a required param of updateOrderItem()');

    const headers = { 'Content-Type': 'application/json', ...additionalHeaders };
    const query = querystring.stringify({ langId });
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/cart/@self/update_order_item${query ? `?${query}` : ''}`;

    const newOrderItem = { partNumber, quantity };

    if (newPartNumber) {
        newOrderItem.xitem_newPartNumber = newPartNumber;
    }

    const body = JSON.stringify({
        orderItem: [newOrderItem],
    });
    return labelRequest(
        authenticatedRequest(new Request(url, { headers: new Headers(headers), method: 'PUT', body }), uberToken, clientId, clientSecret),
        'updateOrderItem',
    );
}
